/** Состояние сессии загрузки в mod-note; file — UUID файла после последнего куска, до него null */
export class Upload {
  upload: string
  size: number
  received: number
  file: string | null

  constructor({ upload, size, received, file }: { upload: string, size: number, received: number, file: string | null }) {
    this.upload = upload
    this.size = size
    this.received = received
    this.file = file
  }
}
